import { Link } from 'react-router-dom';
import './Tags.scss';

const Tags = ({ tags }) => {
  return (
    <div className="Tags">
      {tags.map((tag) => (
        <Link className="tag" to={`/?tag=${tag}`} key={tag}>
          #{tag}
        </Link>
      ))}
    </div>
  );
};

export default Tags;
